/**
 * Design Tokens for Z Modular Theme
 * 
 * Extends the base aster theme tokens with Z Modular branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-aster/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Z Modular brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Z Modular brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Display titles across home sections (FloorplansList, ConvenienceCallout,
    // Testimonials, PropertyOverview, LetsConnect) share this face.
    heading: "'Oswald', 'Arial Narrow', system-ui, sans-serif",
    body: "'Space Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  },
};

export default tokens;
